import {DataService} from '../Services/data.service';
import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {WebSocketService} from '../Services/webSocket.service';
import * as $ from 'jquery';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Person} from '../Model/Person';
import {forEach} from '@angular/router/src/utils/collection';
import {Guest} from '../Model/Guest';
import {SnackPerson} from '../Model/SnackPerson';

@Component({
  selector: 'app-kantine',
  templateUrl: './canteen.component.html',
  styleUrls: ['./canteen.component.css'],
})

export class KantineComponent implements OnInit {
  snackPeople: SnackPerson[] = [];
  users = [];
  usersComming = 0;
  wantSnack = 0
  isModalOpen = false;
  timeout = null;
  searching = false;
  searchResults = [];
  searchCriteria = '';
  modalReference = null;
  druppelId = '';
  personName = '';
  today;
  guest: Guest = {guestID: 0, lunchdate: new Date(), totalnumberofguest: 0, company: '', description: ''};
  months = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];


  @ViewChild('content') addPersonModal: TemplateRef<any>;
  @ViewChild('addPersonToDruppelModal') addPersonToDruppelModal: TemplateRef<any>;
  @ViewChild('personAlreadyCheckedIn') personAlreadyCheckedIn: TemplateRef<any>;
  @ViewChild('addGuestModal') addGuestModal: TemplateRef<any>;

  constructor(private dataService: DataService, public webSocketService: WebSocketService, private router: Router, private modalService: NgbModal) {
    this.today = new Date();
    console.log(this.dataService.role);
    this.checkRole();
  }

  /**
   * Check the role of the logged in {@link Person}
   */
  checkRole(): void {
    if (this.dataService.role.id !== 7) {
      this.router.navigateByUrl('aanmelden');
    }
  }

  /**
   * ngOnInit() is called on start-up
   * Will get all {@link PersonLunch} that had lunch today and add them to the overview
   * Will also get the amount of {@link PersonLunch} that are subscribed to today's lunch
   * After this, it will setup the websocket
   */
  ngOnInit(): void {
    this.dataService.getPersonLunchesOfToday().then((response) => {
      for (let i = 0; i < response.length; i++) {
        if (response[i].person.fullName != null) {
          this.users.unshift(response[i].person.fullName);
          this.snackPeople.unshift(new SnackPerson(response[i].person.fullName, response[i].wantSnack, response[i].lunch))
        } else {
          this.users.unshift(response[i].person.name);
          this.snackPeople.unshift(new SnackPerson(response[i].person.name, response[i].wantSnack, response[i].lunch))
        }
        console.log(response[i]);
        for (let j = 0; j < response[i].guestAmount; j++) {
          this.users.unshift(response[i].guestInformation + ' (Gast)');
        }

      }
    });
    this.dataService.getAmountOfLunchesToday().then((response) => {
      this.usersComming = response;
    });
    this.dataService.getAmountOfSnacksToday().then((response) => {
      this.wantSnack = response;
    })
    this.initWebSocket();
  }
  /**
   * Open the addPersonModal for searching {@link Person}
   * @param content
   */
  openAddPersonModal(content): void {
    this.searchResults = [];
    this.searchCriteria = '';
    console.log(this.isModalOpen);
    if (!this.isModalOpen) {
      this.modalReference = this.modalService.open(content);

      this.modalReference.result.then((result) => {
        console.log(result);
        this.isModalOpen = false;
      }).catch((result) => {
        console.log(result);
        this.isModalOpen = false;
      });
      this.isModalOpen = true;
    }
  }

  openAddGuestModal(addGuest): void {
    console.log(this.isModalOpen);
    if (!this.isModalOpen) {
      this.modalReference = this.modalService.open(addGuest);

      this.modalReference.result.then((result) => {
        console.log(result);
        this.isModalOpen = false;
      }).catch((result) => {
        console.log(result);
        this.isModalOpen = false;
      });
      this.isModalOpen = true;
    }
  }

  openDeletePersonModal(deletePerson): void {
    console.log(this.isModalOpen);
    if (!this.isModalOpen) {
      this.modalReference = this.modalService.open(deletePerson);

      this.modalReference.result.then((result) => {
        console.log(result);
        this.isModalOpen = false;
      }).catch((result) => {
        console.log(result);
        this.isModalOpen = false;
      });
      this.isModalOpen = true;
    }
  }

  openAddNoteModal(addNote): void {
    console.log(this.isModalOpen);
    if (!this.isModalOpen) {
      this.modalReference = this.modalService.open(addNote);

      this.modalReference.result.then((result) => {
        console.log(result);
        this.isModalOpen = false;
      }).catch((result) => {
        console.log(result);
        this.isModalOpen = false;
      });
      this.isModalOpen = true;
    }
  }

  /**
   * search will search for a {@link Person} with the given searchCriteria
   * search a person, will trigger on typing
   * if person stops typing for 500ms, the request will be send
   * checks if the textinput length is more that 1
   * send request to dataservice which will send it to the server
   */
  search(): void {
    // Clear the timeout if it has already been set.
    // This will prevent the previous task from executing
    // if it has been less than <MILLISECONDS>
    clearTimeout(this.timeout);
    const textInput = this.searchCriteria;
    const that = this;
    console.log(textInput);
    if (textInput.length < 1) {
      return;
    }
    // Make a new timeout set to go off in 800ms
    this.timeout = setTimeout(function () {
      console.log('Input Value:', textInput);
      that.searching = true;
      that.dataService.searchPerson(textInput).then((response) => {
        console.log(response);
        that.searchResults = response;
        that.searching = false;
      });
    }, 500);
  }


  /**
   * search will search for a {@link Person} with the given searchCriteria
   * search a person, will trigger on typing
   * if person stops typing for 500ms, the request will be send
   * checks if the textinput length is more that 1
   * send request to dataservice which will send it to the server
   */
  searchForDruppel(): void {
    // Clear the timeout if it has already been set.
    // This will prevent the previous task from executing
    // if it has been less than <MILLISECONDS>
    clearTimeout(this.timeout);
    const textInput = this.searchCriteria;
    const that = this;
    console.log(textInput);
    if (textInput.length < 1) {
      return;
    }
    // Make a new timeout set to go off in 800ms
    this.timeout = setTimeout(function () {
      console.log('Input Value:', textInput);
      that.searching = true;
      that.dataService.searchPersonForDruppel(textInput).then((response) => {
        console.log(response);
        that.searchResults = response;
        that.searching = false;
      });
    }, 500);
  }

  /**
   * add person tot the lunch of today
   * @param {Person} person
   */
  addPerson(person: Person): void {
    console.log(this.modalReference);
    this.dataService.addPersonDefinitive(person).then((response) => {
      this.modalReference.close();
    });
  }

  deletePersonFromLunch(person: Person): void {
    console.log(this.modalReference);
    this.dataService.deletePerson(person).then((response) => {

    });
    this.modalReference.close();
  }

  addGuest(company, description, numberOfGuest): void {
    this.guest.lunchdate = this.today;
    this.guest.description = description;
    this.guest.company = company;
    this.guest.totalnumberofguest = numberOfGuest;
    console.log(this.guest);
    this.dataService.addGuest(this.guest);
  }

  sendNote(message): void {
    this.dataService.addNote(message);
  }

  /**
   * add person tot the lunch of today
   * @param {Person} person
   * @param druppelId
   */
  addPersonToDruppel(person: Person, druppelId: string): void {
    person.druppelId = druppelId;
    this.dataService.addDruppelToPerson(person).then((response) => {
      console.log(response);
      console.log(person);
      this.modalReference.close();
    })
  }

  /**
   * setup the websocket connection
   * function will call the webSocketService for initializing the setup
   * after getting the setup the client will try to connect.
   * Everytime a message comes in, the message will be added to the overview
   */
  initWebSocket = function () {
    this.stompClient = this.webSocketService.initializeWebSocketConnection();
    const that = this;
    this.stompClient.connect({}, function (frame) {
      that.webSocketService.WSconnected = true;
      that.stompClient.subscribe('/lunch', (message) => {
        console.log(message.body );
        $('.userList').fadeOut(function () {
          if (that.isModalOpen) {
            that.modalReference.close();
          }
          if (message.body) {
            const split = message.body.split(';');
            let wantSnack = false;
            console.log(split[2]);
            if (Number(split[2]) === 1 && Number(split[1]) === 1) {
              wantSnack = true;
              console.log('want snack');
            }
            let hasRegistered = true;
            if (Number(split[1]) === 0) {
              hasRegistered = false;
            }
            const snackPerson = new SnackPerson(split[0], wantSnack, hasRegistered);
            console.log(snackPerson);
            that.snackPeople.unshift(snackPerson)
            that.users.splice(0, 0, message.body);
            $('.userList').fadeIn();
          }
        })
      });
      that.stompClient.subscribe('/lunch/newUser', (message) => {
        if (!that.isModalOpen) {
          that.openAddPersonModal(that.addPersonToDruppelModal);
          that.druppelId = message.body;
          console.log(message);
        }
      });
      that.stompClient.subscribe('/lunch/userAlreadyLoggedIn', (message) => {
        if (!that.isModalOpen) {
          that.openAddPersonModal(that.personAlreadyCheckedIn);
          that.personName = message.body;
          console.log(message);
        }
      });
      that.stompClient.subscribe('/lunch/deletePersonFromLunchToday', (message) => {
        if (!that.isModalOpen) {
          $('.userList').fadeOut(function () {
            console.log(message.body);
            if (message.body) {
              const index = that.snackPeople.findIndex(value => value.name = message.body);
              if (index > -1) {
                that.snackPeople.splice(index, 1);
              }

            }

          })
          $('.userList').fadeIn();
          if (that.isModalOpen) {
            that.modalReference.close();
          }
        }
      });
    }, (e) => {
      console.log(e);
      console.log('error');
      that.webSocketService.stompClient.disconnect();
      that.webSocketService.WSconnected = false;
    });
  }

  destroyWebsocket(): void {
    this.webSocketService.stompClient.disconnect();
  }
}



// WEBPACK FOOTER //
// ./src/app/Canteen/canteen.component.ts